import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

import { useAppSelector } from '../../hooks';
import { getUser } from '../../store';
import { environment } from '../../environments';

export const GoogleAnalyticsInitializer = () => {
  const currentUser = useAppSelector(getUser);

  useEffect(() => {
    if (currentUser) {
      TagManager.initialize({
        gtmId: environment.gtmID || '',
        dataLayer: { user_id: currentUser.employeeID },
      });
    }
  }, [currentUser]);

  return null;
};
